



















import { Component, Prop, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import StatementModule from '@/store/modules/Statement';
import Table from '@/components/Table/Index.vue';
import StatementBody from '@/components/Table/StatementBody.vue';
import Pagination from '@/components/Pagination.vue';
import DepositWithdrawData from '@/data/DepositWithdrawData';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Pagination,
    StatementBody,
  },
})
export default class Statement extends Mixins(ErrorHandleMixin, PaginationMixin) {
  @Prop() readonly statementCriteria!: any;

  @Prop() readonly period!: any;

  StatementInstance = getModule(StatementModule, this.$store);

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  dataList: any = [];

  TableHead: Array<object> = [...DepositWithdrawData.TableHeadDetail];

  sum = 0;

  created() {
    this.fetchStatement();
  }

  async fetchStatement() {
    const criteria = {
      ...this.statementCriteria,
      ...this.period,
      current: this.PaginationDetail.current,
      size: this.PaginationDetail.size,
    };
    const res = await this.StatementInstance.FetchStatementDetail(criteria);
    if (!['ADMIN', 'SUPERADMIN'].includes(this.AuthInstance.user.role)) {
      this.TableHead[0] = [...DepositWithdrawData.TableHeadDetail[0]]
        .filter((item: any) => !item.isAdmin);
    }
    if (res.code) {
      this.checkError(res);
    } else {
      this.dataList = res.logs;
      this.PaginationDetail.amount = res.pageAmount;
      this.sum = res.footer;
    }
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchStatement();
  }
}
